import React, { Component } from "react";
import { Field, reduxForm, change, initialize, reset } from "redux-form";
import submit from "./submit";
import validate from "./validate";
import { connect } from "react-redux";
import { graphql, gql, compose } from "react-apollo";
import cx from "classnames";
import {
  Button,
  FormGroup,
  Col,
  FormControl,
  Panel,
  Grid,
  Row,
} from "react-bootstrap";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import s from "./FaqForm.css";
import bt from "../../../components/commonStyle.css";
import { object } from "twilio/lib/base/serialize";

// Translation
import { FormattedMessage, injectIntl } from "react-intl";
import messages from "../../../locale/messages";
import InputFieldComponent from "../../Common/FormField/InputFieldComponent";

class FaqForm extends Component {
  static defaultProps = {};

  constructor(props) {
    super(props);

    this.state = {
      addMore: ["1"],
      addMoreCount: 1,
    };
    this.handleAddMore = this.handleAddMore.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
  }

  componentDidMount() {
    const { initialValues, flattenFaq } = this.props;

    const { addMore, addMoreCount } = this.state;
    if (initialValues?.faqItems?.length < 1) {
      this.setState({
        addMore: ["1"],
        addMoreCount: 1,
      });
    } else {
      this.setState({
        addMore: initialValues?.faqItems,
        addMoreCount: initialValues?.faqItems?.length,
      });
    }
  }

  handleAddMore() {
    const { addMore, addMoreCount } = this.state;

    let count = addMoreCount + 1;
    let addMoreUpdate = addMore.concat(`${count}`);
    this.setState({
      addMore: addMoreUpdate,
      addMoreCount: count,
    });
  }

  async handleRemove() {
    const { addMore, addMoreCount } = this.state;
    const { change } = this.props;
    addMore.pop();

    if (addMore.length <= 0) {
      addMore.push("1");
    }
    let count = addMoreCount - 1;

    if (count >= 1) {
      this.setState({
        addMore: addMore,
        addMoreCount: count,
      });

      // await change("faqItems", addMore);
    }
    await change(`faqItems[${count}].title`, "");
    await change(`faqItems[${count}].content`, "");
    await change(`faqItems[${count}].id`, "");
  }

  isRemoveDisabled() {
    const { faqItems } = this.props;
    if (
      faqItems?.length === 1 &&
      (!faqItems[0]?.title || faqItems[0]?.title.trim() === "") &&
      (!faqItems[0]?.content || faqItems[0]?.content.trim() === "")
    ) {
      return true;
    }
    return false;
  }

  render() {
    const {
      error,
      handleSubmit,
      submitting,
      dispatch,
      initialValues,
      type,
      flattenFaq,
      title,
    } = this.props;
    const { formatMessage } = this.props.intl;
    const { addMore } = this.state;

    return (
      <div
        className={cx(
          s.pagecontentWrapper,
          "pagecontentAR",
          type === "Home" && s.pageContentWrapperWithoutMargin
        )}
      >
        <Grid fluid>
          <Row className={`frontend-faq`}>
            <Col lg={12} md={12} sm={12} xs={12}>
              <h1 className={s.headerTitle}>
                <FormattedMessage
                  {...(type === "faqs"
                    ? messages.HostListingWebsiteTab
                    : messages.whyBecomeHostBlock7)}
                />
              </h1>
            </Col>
            <Col
              xs={12}
              sm={12}
              md={12}
              lg={type === "Home" ? 12 : 8}
              className={`${s.blockcenter} faq-margin-top ${
                type === "Home" ? s.blockcenterWithoutMargin : ""
              }`}
            >
              <Panel
                className={cx(
                  s.panelHeader,
                  "bgBlack border-none",
                  type === "Home" && s.panelHeaderWithoutPadding
                )}
              >
                <form
                  onSubmit={handleSubmit((values) => {
                    const { listId } = this.props;
                    // Update addMore state with current title and content
                    if (Array.isArray(values.faqItems)) {
                      const nonEmptyFaqs = values.faqItems.filter(
                        (item) =>
                          (item?.title && item.title.trim() !== "") ||
                          (item?.content && item.content.trim() !== "")
                      );
                      this.setState({
                        addMore: nonEmptyFaqs,
                        addMoreCount: nonEmptyFaqs.length,
                      });
                    }
                    if (values?.faqItems?.length < 1) {
                      this.setState({
                        addMore: ["1"],
                        addMoreCount: 1,
                      });
                    }
                    const submissionData = {
                      ...values,
                      listId,
                    };
                    // Call original submit handler
                    submit(submissionData);
                  })}
                >
                  {error && <strong>{formatMessage(error)}</strong>}
                  {type === "faqs" && (
                    <Field
                      name={`faqsDescription`}
                      type="text"
                      component={InputFieldComponent}
                      componentClass="textarea"
                      label={formatMessage(messages.faqDescription)}
                      placeholder={formatMessage(messages.faqDescription)}
                    />
                  )}

                  {addMore?.map((faq, index) => {
                    return (
                      <div key={index} className="mb-4">
                        {/* Hidden ID field */}
                        <Field
                          name={`faqItems[${index}].id`}
                          component="input"
                          type="hidden"
                        />

                        {/* Title */}
                        <Field
                          name={`faqItems[${index}].title`}
                          type="text"
                          component={InputFieldComponent}
                          label={`${formatMessage(messages.faqBlockTitle)} ${
                            index + 1
                          }`}
                          placeholder={formatMessage(messages.faqBlockTitle)}
                          inputClass={bt.commonControlInput}
                        />

                        {/* Content */}
                        <Field
                          name={`faqItems[${index}].content`}
                          component={InputFieldComponent}
                          componentClass="textarea"
                          label={`${formatMessage(messages.faqBlockContent)} ${
                            index + 1
                          }`}
                        />
                      </div>
                    );
                  })}
                  <div className={s.displayFlex}>
                    <Button
                      className={cx(bt.btnPrimary, bt.btnLarge, s.btnWidth)}
                      type="button"
                      disabled={submitting}
                      onClick={() => this.handleAddMore()}
                    >
                      <FormattedMessage {...messages.addLabel} />
                    </Button>
                    <Button
                      className={cx(bt.btnPrimary, bt.btnLarge, s.btnWidth)}
                      type="submit"
                      disabled={submitting}
                    >
                      <FormattedMessage {...messages.save} />
                    </Button>
                    <Button
                      className={cx(
                        bt.btnPrimaryBorder,
                        bt.btnLarge,
                        s.btnWidth,
                        "bgBlack",
                        "bgBlackHover"
                      )}
                      type="button"
                      disabled={submitting || this.isRemoveDisabled()}
                      onClick={() => this.handleRemove()}
                    >
                      <FormattedMessage {...messages.remove} />
                    </Button>
                  </div>
                </form>
              </Panel>
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}
FaqForm = reduxForm({
  form: "WhyHostForm",
  validate,
})(FaqForm);

let mapState = (state) => {
  return { listId: state?.location?.listingSteps?.listId };
};

let mapDispatch = {
  change,
  // reset
};

export default injectIntl(
  withStyles(s, bt)(connect(mapState, mapDispatch)(FaqForm))
);
